// ./src/components/ServiceSelect.js
import React from 'react';
import { FormControl, MenuItem, InputLabel } from '@mui/material';
import { Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SERVICES } from '../constants/appConstants';
import { useMessageHandler } from '../contexts/MessageContext';

export default function ServiceSelect({ selectedService, setSelectedService, disabled, onEngineChange }) {
  const { webSearchActive, setWebSearchActive, messages } = useMessageHandler();
  const { t } = useTranslation();

  const isWebSearchDisabled = messages.length > 0 && !webSearchActive;

  const handleServiceChange = (event) => {
    const newService = event.target.value;
    if (newService === 'webSearch') {
      setWebSearchActive(true);
      // Force Gemini engine selection
      onEngineChange('gemini');
    }
    setSelectedService(newService);
  };

  const handleChange = (event) => {
    setSelectedService(event.target.value);
  };

  return (
    <FormControl variant="outlined" fullWidth margin="dense">
      <InputLabel shrink>{t('service.selectLabel')}</InputLabel>
      <Select
        label={t('service.selectLabel')}
        value={selectedService}
        onChange={handleServiceChange}
        displayEmpty
        disabled={disabled}
      >
        {SERVICES.map((service) => (
          <MenuItem
            key={service.key}
            value={service.key}
            //disabled={service.key === 'webSearch' && isWebSearchDisabled}
          >
            {service.key === '' ? <small><em>{t(service.text)}</em></small> : t(service.text)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
